var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_68764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.409966 11.01L9.00996 2.40996C9.14004 2.27995 9.29445 2.17684 9.46437 2.1065C9.6343 2.03617 9.81641 1.99999 10.0003 2.00004C10.3717 2.00013 10.7279 2.14777 10.9905 2.41046C11.253 2.67316 11.4005 3.0294 11.4004 3.40082C11.4003 3.77223 11.2527 4.1284 10.99 4.39096L3.37996 12.001L10.99 19.609C11.2525 19.8717 11.4 20.2279 11.3999 20.5993C11.3998 20.9707 11.2522 21.3269 10.9895 21.5895C10.7268 21.852 10.3705 21.9995 9.99911 21.9994C9.6277 21.9993 9.27153 21.8517 9.00897 21.589L0.408966 12.99C0.278471 12.8602 0.174911 12.706 0.104244 12.5361C0.0335779 12.3662 -0.0028019 12.184 -0.0028019 12C-0.0028019 11.816 0.0335779 11.6338 0.104244 11.4639C0.174911 11.294 0.278471 11.1397 0.408966 11.01H0.409966Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90002 13.5L21.9 13.5C22.7285 13.5 23.4 12.8284 23.4 12C23.4 11.1716 22.7285 10.5 21.9 10.5L3.90002 10.5C3.0716 10.5 2.40002 11.1716 2.40002 12C2.40002 12.8284 3.0716 13.5 3.90002 13.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_68764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.bffb9166.svg";
export { ForwardRef as ReactComponent };